// extracted by mini-css-extract-plugin
module.exports = {"root":"Tags_root__dyjU_","tag":"Tags_tag__pVCG6","outlined":"Tags_outlined__bCyGa","filled":"Tags_filled__OLRJf"};